import { AdvancedPlansFeature, StringMap } from 'types';

export function isIncludedBySpec(feature: AdvancedPlansFeature, experiments: StringMap) {
  if (typeof feature.includedBySpec === 'string') {
    return experiments[feature.includedBySpec] === 'true';
  }
  return feature.includedBySpec?.some(
    (spec) => experiments[spec] === 'true',
  );
}

export function isExcludedBySpec(feature: AdvancedPlansFeature, experiments: StringMap) {
  if (typeof feature.excludedBySpec === 'string') {
    return experiments[feature.excludedBySpec] !== 'true';
  }
  return !feature.excludedBySpec?.some(
    (spec) => experiments[spec] === 'true',
  );
}


export function filterFeaturesBySpec(
  features: AdvancedPlansFeature[],
  experiments: StringMap,
): AdvancedPlansFeature[] {
  return features.filter((feature) => {

    if (feature.includedBySpec && feature.excludedBySpec) {
      const isInclude = isIncludedBySpec(feature, experiments);
      const isExclude = isExcludedBySpec(feature, experiments);
      return isInclude && !isExclude;
    }

    if (feature.includedBySpec) {
      return isIncludedBySpec(feature, experiments);
    }

    if (feature.excludedBySpec) {
      return isExcludedBySpec(feature, experiments);
    }

    return true;
  });
}
